/** Therapist names assigned to a booking (primary + any co-therapists). */
export const getBookingTherapistNames = (booking) => {
  const names = new Set();
  if (Array.isArray(booking?.therapists)) {
    booking.therapists.forEach((t) => {
      if (t?.name) names.add(t.name);
    });
  }
  const primary = booking?.therapist || booking?.therapist_name;
  if (primary) names.add(primary);
  return names;
};

/** True if the therapist is assigned to this booking (primary or secondary). */
export const bookingIncludesTherapist = (booking, therapistName) => {
  if (!booking || !therapistName) return false;
  return getBookingTherapistNames(booking).has(therapistName);
};
